var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"vehicle-list",attrs:{"title":"Nyheder"}},[_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":_vm.createNews},slot:"tools"}),_c('new-table-view',{ref:"table",attrs:{"columns":[
		{
			label: 'Dato',
			name: 'created',
			filter: 'timestamp'
		},
		{
			label: 'Overskrift',
			name: 'title'
		},
		{
			label: 'Uddrag',
			name: 'content'
		},
		{
			label: 'Vedhæftede filer',
			name: ['_embedded', 'file_count'],
		},
		{
			label: '',
			name: 'delete',
			align: 'right',
			template: {
				name: 'button',
				label: 'Slet'
			}
		},
	],"items":_vm.items,"pagination":_vm.pagination},on:{"itemClick":_vm.itemClick,"delete":_vm.itemDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }